<template>
    <div>
        <div class="container remove-padding-margin" id="datarak">
            <div class="modal fade" id="deletemodalrak" role="dialog">
                <div class="modal-dialog modal-lg  bani-modal">
                    <div class="modal-content">
                        <div class="modal-header" v-if="validateAccess('rack.delete')">
                            <div class="nav-btn kiri"></div>
                            <h5 class="navbar-title text-center">Hapus Rak</h5>
                            <div class="nav-btn kanan tutup">
                                <img src="../../assets/img/x2.svg" data-dismiss="modal" alt="">
                            </div>
                        </div>
                        <div class="modal-body">
                            <p class="font-14 remove-padding-margin">Apakah anda yakin ingin menghapus rak <b>{{namarak}}? </b>Tindakan ini juga akan menghapus data rak yang ada didalamnya.</p>
                        </div>
                        <div class="modal-footer" v-if="validateAccess('rack.delete')">
                            <button type="button" class="btn btn-outline-primary btn-long" data-dismiss="modal"
                                    @click="deleterak">Hapus Rak
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="header-top bg-white">
                <div class="nav-center showPageDefault">
                    <div class="row set-row d-flex w-limit">
                        <div class="remove-padding navbar-icon-left" @click="back">
                            <img class="remove-padding-margin" @click="" src="../../assets/gambar/back-blue.svg">
                        </div>
                        <div class="text-center remove-padding flex-1 font-weight-600">
                            Daftar Rak
                        </div>
                        <div class="navbar-icon-right remove-padding remove-margin">
                            <img class="imageSearch remove-margin" src="../../assets/icons/search.svg" @click="showSearch" alt="" id="iconsearchrak">
                        </div>
                    </div>
                </div>

                <div class="row justify-content-center align-items-center set-row showPageSearch w-limit">
                    <div class="col-md-9 col-sm-9 col-9 remove-padding">
                        <input class="inputSearch" id="input_searchRak" type="text" v-model="searchKey"
                               placeholder="Cari..">
                    </div>
                    <div class="col-md-3 col-sm-3 col-3 remove-padding">
                        <img class="imageSearch" @click="closeSearch" src="../../assets/img/x2.svg" alt="">
                    </div>
                </div>
            </div>
            <main class="add-padding-default bg-gray w-limit">
                <div id="loading-bar-spinner" class="spinner">
                    <div class="spinner-icon"></div>
                </div>
                <div class="flex-100 showPageSearch">
                    <div class="flex-1" v-if="rakSearch.length >= 0">
                        <div class="Search-BOX mar-top-60 mar-bottom-16" id="textTopRak"></div>
                        <div class="">
                            <div class="row set-card" v-for="rs in rakSearch" :key="rs.idrak" @click="showdroprak(rs.idrak)">
	                            <div class="col-md-10 col-sm-10 col-10 text-left remove-padding"
                                     @click="detailraks(rs.idrak)">
                                    <div class="font-14 align-items-center remove-margin f-16" style="line-height: 21px; margin-bottom: 6px">
                                        <b v-html="searchHighlight(rs.nama, searchKey)"></b></div>
                                    <div>
                                        <div>
                                            <img src="../../assets/icons/file.svg" alt=""><span class="f-14 f-c-midgrey"> {{ rs.nota_transaksi }} Nota Transaksi</span>
                                        </div>
                                    </div>
                                    <div>
                                        <div>
                                            <img src="../../assets/icons/inbox.svg" alt=""><span class="f-14 f-c-midgrey"> {{ rs.pack_terisi }} Pack Tersisi</span>
                                        </div>

                                    </div>
                                    <div>
                                        <div>
                                            <img src="../../assets/icons/tagging.svg" alt=""><span class="f-14 f-c-midgrey"> {{rs.tagrak}}</span>
                                        </div>

                                    </div>
                                </div>
	                            <div class="col-md-2 col-sm-2 col-2 text-right remove-padding dropdown"
	                                 :id="'dropdownrak'+rs.idrak" data-toggle="dropdown" aria-haspopup="true"
	                                 aria-expanded="false">
		                            <img src="../../assets/icons/more-horizontal2.svg" alt="">
		                            <div class="dropdown-menu garis-deposit" aria-labelledby="dropdownMenuLinklist">
			                            <a class="dropdown-item icon-1" href="#" @click="detailraks(rs.idrak)" v-if="validateAccess('rack.read')"><span
				                            class="mar-right-10"><i class="far fa-file color-206CF"></i></span>Detail</a>
			                            <a class="dropdown-item icon-1" href="#" @click="edits(rs.idrak)" v-if="validateAccess('rack.update')"><span
				                            class="mar-right-10"><i class="far fa-edit color-206CF"></i></span>Ubah</a>
			                            <a class="dropdown-item icon-2" href="#" @click="showmodaldel(rs,k)" v-if="validateAccess('rack.delete')"><span
				                            class="mar-right-10"><img src="../../assets/icons/trash-2.svg"></span>Hapus</a>
		                            </div>
	                            </div>
<!--                                <div class="col-md-6 col-sm-6 col-6 text-right remove-padding">-->
<!--                                    <img style="width: 15px;" src="../../assets/icons/more-horizontal2.svg" alt="">-->
<!--                                    <div class="test" :id="'dropdownrak'+rs.idrak">-->
<!--                                        <div class="" style="padding: 10px 9px"  @click="detailraks(rs.idrak)"><img src="../../assets/icons/file-text.svg">-->
<!--                                            <span class="mar-right-10"></span>Detail</div>-->
<!--                                        <div class="" style="padding: 10px 12px" @click="edits(rs.idrak)"><img src="../../assets/icons/edit_2.svg">-->
<!--                                            <span class="mar-right-10"></span>Ubah</div>-->
<!--                                        <div class="" style="padding: 10px 6px"  @click="showmodaldel(rs,k)"><img src="../../assets/icons/trash-2.svg">-->
<!--                                            <span class="mar-right-10"></span>Hapus</div>-->
<!--                                    </div>-->
<!--                                </div>-->
	                            <div class="loadmoreSpinner" id="loadingSpinnerRakSearch" style="display: none">
		                            <center>
			                            <div class="sp sp-circle"></div>
		                            </center>
	                            </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex-100 showPageDefault" id="flex-100">
                    <div class="flex-1" v-if="leght_data === 0">
                        <div class="image text-alignC">
                            <img class="img-fluid" src="../../assets/icons/Hanger.svg" alt="">
                            <h5 class="text-center">Belum ada jenis rak yang terdaftar</h5>
                            <h6 class="text-center">Silahkan klik tombol + untuk menambahkan</h6>
                        </div>
                    </div>
                    <div class="flex-1" v-else>
                        <transition name="fade">
                            <div class="loading" v-show="loading">
                                <span class="fa fa-spinner fa-spin"></span> Loading
                            </div>
                        </transition>
                        <div class="card-2 boxer" id="cardrak">
                            <h6>Total {{leght_data}} Rak</h6>
<!--                            <div class="dropdown-sortir" style="margin-top: -37px">-->
<!--                                <button class="btn btn-secondary dropdown-toggle" type="button"-->
<!--                                        id="dropdownMenuButton2" data-toggle="dropdown" aria-haspopup="true"-->
<!--                                        aria-expanded="false">-->
<!--                                    Urutkan-->
<!--                                </button>-->
<!--                                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton2">-->
<!--                                    <a class="dropdown-item" href="#" v-on:click="selectSortingRaks('asc')">Urut-->
<!--                                        Dari A-->
<!--                                        - Z</a>-->
<!--                                    <a class="dropdown-item" href="#"-->
<!--                                       v-on:click="selectSortingRaks('desc')">Urut-->
<!--                                        Dari Z-->
<!--                                        - A</a>-->
<!--                                    <a class="dropdown-item" href="#"-->
<!--                                       v-on:click="selectSortingRaks('terbaru')">Urut-->
<!--                                        Dari Terbaru</a>-->
<!--                                    <a class="dropdown-item" href="#"-->
<!--                                       v-on:click="selectSortingRaks('terlama')">Urut-->
<!--                                        Dari Terlama</a>-->
<!--                                </div>-->
<!--                            </div>-->
	                        <FilterSorting :jenisFilter="'rak'" @filter="filter" />
                            <br>
                            <div class="row set-card" v-for="(r,k) in rak" :key="r.idrak" @click="showdroprak(r.idrak)">
                                <div class="col-md-10 col-sm-10 col-10 text-left remove-padding"
                                     @click="detailraks(r.idrak)">
                                    <div class="font-14 align-items-center remove-margin f-16" style="line-height: 21px; margin-bottom: 6px">
                                        <b>{{r.nama}}</b></div>
                                    <div>
                                        <div>
                                            <img src="../../assets/icons/file.svg" alt=""><span class="f-14 f-c-midgrey"> {{ r.nota_transaksi }} Nota Transaksi</span>
                                        </div>
                                    </div>
                                    <div>
                                        <div>
                                            <img src="../../assets/icons/inbox.svg" alt=""><span class="f-14 f-c-midgrey"> {{ r.pack_terisi }} Pack Tersisi</span>
                                        </div>

                                    </div>
                                    <div>
                                        <div>
                                            <img src="../../assets/icons/tagging.svg" alt=""><span class="f-14 f-c-midgrey"> {{r.tagrak}}</span>
                                        </div>

                                    </div>
                                </div>
	                            <div class="col-md-2 col-sm-2 col-2 text-right remove-padding dropdown"
	                                 :id="'dropdownrak'+r.idrak" data-toggle="dropdown" aria-haspopup="true"
	                                 aria-expanded="false">
		                            <img src="../../assets/icons/more-horizontal2.svg" alt="">
		                            <div class="dropdown-menu garis-deposit" aria-labelledby="dropdownMenuLinklist">
			                            <a class="dropdown-item icon-1" href="#" @click="detailrak(r.idrak)" v-if="validateAccess('rack.read')"><span
				                            class="mar-right-10"><i class="far fa-file color-206CF"></i></span>Detail</a>
			                            <a class="dropdown-item icon-1" href="#" @click="edit(r.idrak)" v-if="validateAccess('rack.update')"><span
				                            class="mar-right-10"><i class="far fa-edit color-206CF"></i></span>Ubah</a>
			                            <a class="dropdown-item icon-2" href="#" @click="showmodaldel(r,k)" v-if="validateAccess('rack.delete')"><span
				                            class="mar-right-10"><img src="../../assets/icons/trash-2.svg"></span>Hapus</a>
		                            </div>
	                            </div>
<!--                                <div class="col-md-6 col-sm-6 col-6 text-right remove-padding">-->
<!--                                    <img style="width: 15px;" src="../../assets/icons/more-horizontal2.svg" alt="">-->
<!--                                    <div class="test" :id="'dropdownrak'+r.idrak">-->
<!--                                        <div class="" style="padding: 10px 9px"  @click="detailrak(r.idrak)"><img src="../../assets/icons/file-text.svg">-->
<!--                                            <span class="mar-right-10"></span>Detail</div>-->
<!--                                        <div class="" style="padding: 10px 12px" @click="edit(r.idrak)"><img src="../../assets/icons/edit_2.svg">-->
<!--                                            <span class="mar-right-10"></span>Ubah</div>-->
<!--                                        <div class="" style="padding: 10px 6px"  @click="showmodaldel(r,k)"><img src="../../assets/icons/trash-2.svg">-->
<!--                                            <span class="mar-right-10"></span>Hapus</div>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                                <div class="col-md-6 col-sm-6 col-6 text-right remove-padding dropdown"-->
<!--                                     :id="'dropdownMenuLink' + r.idrak" data-toggle="dropdown" aria-haspopup="true"-->
<!--                                     aria-expanded="false">-->
<!--                                    <img style="width: 15px;" src="../../assets/icons/more-horizontal2.svg" alt="">-->
<!--                                    <div class="dropdown-menu garis-rak" :aria-labelledby="'dropdownMenuLink' + r.idrak">-->
<!--                                        <a class="dropdown-item icon-1" href="#" @click="edit(r.idrak)"><span-->
<!--                                                class="mar-right-10"><i class="far fa-edit color-206CF"></i></span>Ubah</a>-->  
<!--                                        <a class="dropdown-item icon-2" href="#" @click="showmodaldel(r,k)"><span-->
<!--                                                class="mar-right-10"><img src="../../assets/icons/trash-2.svg"></span>Hapus</a>-->
<!--                                    </div>-->
<!--                                </div>-->
                            </div>
	                        <div class="loadmoreSpinner" id="loadingSpinnerRak" style="display: none">
		                        <center>
			                        <div class="sp sp-circle"></div>
		                        </center>
	                        </div>
                        </div>
                    </div>
	                <div class="flying-button-wrapper" v-if="validateAccess('rack.create')">
		                <div class="flying-inside">
			                <div class="flying-button btn-add-outlet" @click="create"></div>
		                </div>
	                </div>
                </div>
            </main>
        </div>
    </div>
</template>

<script>
	import FilterSorting from "@/component-items/FilterSorting";

    export default {
        name: "DataRak",
        props:['setidoutletserak'],
	    components: { FilterSorting },
        data() {
            return {
                namarak: '',
                awal: '',
                akhir: '',
                searchKey: '',
                rak: [],
                leght_data:0,
                rakSearch: [],
                idoutlet: '',
                idrak: '',
                keyrak: 0,
                isClicked:true,
                loading:false,
                nextItem: 1,
                limit_data: 20,
                page_number: 1,
                requestHeaders: {
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    }
                },
	            rakPagination: {
		            limit: 20,
		            offset:0,
		            length: 0,
		            pageNumber: 0,
		            sortBy: "nama",
		            orderBy: "ASC",
	            },
	            rakSearchPagination: {
		            limit: 20,
		            offset:0,
		            length: 0,
		            pageNumber: 0,
		            sortBy: "nama",
		            orderBy: "ASC",
		            key: ""
	            },
	            listRakCalled: false,
            }
        },
        mounted() {
            $(".spinner").prop("style", "display:none");
            $(".showPageSearch").prop("style", "display:none");
            this.idoutlet = this.$route.params.idoutlet;
            // this.scrollLoaderRak()
            if (!this.listRakCalled) {
                this.listRakCalled = true
                this.scroll()
		        }
        },
        methods: {
	        scroll() {
		        window.onscroll = () => {
			        if ($('#loadingSpinnerRak').is(":hidden")) {
				        if ($(".showPageDefault").is(":visible")) {
					        if (this.rakPagination.pageNumber <= Math.ceil(this.rakPagination.length / this.rakPagination.limit)) {
						        if (Math.floor($(window).scrollTop()) > 0 && Math.floor($(window).scrollTop()) >= Math.floor($(document).height() - $(window).height()) - 100) {
							        this.rakPagination.offset = (this.rakPagination.pageNumber * this.rakPagination.limit);
							        this.getrak();
							        $('#loadingSpinnerRak').show()
						        }
					        }
				        }
			        }
			
			        if ($('#loadingSpinnerRakSearch').is(":hidden")) {
				        if ($(".showPageSearch").is(":visible")) {
					        if (this.rakSearchPagination.pageNumber <= Math.ceil(this.rakSearchPagination.length / this.rakSearchPagination.limit)) {
						        if (Math.floor($(window).scrollTop()) > 0 && Math.floor($(window).scrollTop()) >= Math.floor($(document).height() - $(window).height()) - 100) {
							        this.rakSearchPagination.offset = (this.rakSearchPagination.pageNumber * this.rakSearchPagination.limit);
							        this.searchRak()
							        $('#loadingSpinnerRakSearch').show()
						        }
					        }
				        }
			        }
		        }
	        },

            back(){
	            this.rakPagination = {
		            limit: 20,
			            offset:0,
			            length: 0,
			            pageNumber: 0,
			            sortBy: "nama",
			            orderBy: "ASC",
	            }
	            this.rakSearchPagination = {
		            limit: 20,
			            offset:0,
			            length: 0,
			            pageNumber: 0,
			            sortBy: "nama",
			            orderBy: "ASC",
	            }
	            this.listRakCalled = false;
	        	
                this.$emit('backtodetail');
                $('#dropdownMenuButton2').text("Urutkan")
                $('.test').hide();
            },

            edit(idrak){
                setTimeout(function () {
                    $('.test').hide();
                },50);
                this.$emit('Edit',idrak);
                $('#dropdownMenuButton2').text("Urutkan")
            },

            edits(idrak){
                setTimeout(function () {
                    $('.test').hide();
                },50);
                this.$emit('Edit',idrak)
                this.closeSearch()
                $('#dropdownMenuButton2').text("Urutkan")
            },

            detailrak(idrak){
                if (!this.validateAccess('rack.read')) return
                setTimeout(function () {
                    $('.test').hide();
                },50);
                $('#dropdownMenuButton2').text("Urutkan");
                this.$emit('detailrak',idrak);
            },

            detailraks(idrak){
                if (!this.validateAccess('rack.read')) return
                setTimeout(function () {
                    $('.test').hide();
                },50);
                this.$emit('detailrak',idrak);
                this.closeSearch();
                $('#dropdownMenuButton2').text("Urutkan");
            },

            create(){
                this.$emit('createrak');
                $('#dropdownMenuButton2').text("Urutkan")
                $('.test').hide();
            },

            showmodaldel(r) {
                this.idrak = r.idrak
                this.namarak=r.nama
                $('#deletemodalrak').modal('show')
            },

            handleScroll(){
              // alert("Yeah")
            },

            showdroprak(idrak){
                if (!this.validateAccess('rack.read')) return
                $('.test').hide();
                $('#dropdownrak'+idrak).show();
            },


            showSearch(){
                $(".showPageSearch").show()
                $(".showPageSearch").addClass('animated slideInDown')
                $("#textTopRak").text("Minimal 2 karakter")
                $(".showPageDefault").hide();
                $("#input_searchRak").focus();
            },

            closeSearch(){
                $(".showPageSearch").hide()
                $(".showPageSearch").removeClass('animated slideInDown')
                $(".showPageDefault").show();
                this.rakSearch = [];
                this.searchKey = "";
                $("#textTopRak").text("Minimal 3 karakter")
	            this.rakSearchPagination = {
		            limit: 20,
		            offset:0,
		            length: 0,
		            pageNumber: 0,
		            sortBy: "nama",
		            orderBy: "ASC",
	            }
            },
            //func add//
            //func add//
            //func edit//
            //akhir func edit//
            // func delete //
            async deleterak(){
                $('#loadingPage').show();
                $('#loadingPage').addClass('overlayLoading');
                try {
                    const deleterak = new FormData()
                    const response = await this.$axios.post(this.$baseurl + '/masterData/rak/delete_rak?idrak=' + this.idrak + '&idoutlet=' + this.setidoutletserak , deleterak, this.requestHeaders);
                    if(response.data.status===true){
                        this.getrak(true)
                        $('#loadingPage').removeClass('overlayLoading');
                        $('#loadingPage').hide();
                        this.$toast.success(response.data.msg)
                    }

                }catch (e) {
                	this.$catch_error_response(e)
                    $('#loadingPage').hide();
                    $('#loadingPage').removeClass('overlayLoading');
                }
            },
            //akhir func delete//
            //fungsi search rak//
            searchRak() {
                $("#textTopRak").text("Minimal 2 karakter")
                if (this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.timer = setTimeout(() => {
                    // $(".spinner").prop("style", "display:inline-block");
                    this.searchRakFunc();
                }, 500);
            },

            async searchRakFunc() {
	            var key = this.searchKey
	        	if (this.rakSearchPagination.offset === 0 || this.rakSearchPagination.key !== key) {
			        $('#loadingPage').show();
			        $('#loadingPage').addClass('overlayLoading');
			        $("#textTopRak").text("Sedang mencari...")
			        this.rakSearchPagination = {
				        limit: 20,
				        offset:0,
				        length: 0,
				        pageNumber: 0,
				        sortBy: "nama",
				        orderBy: "ASC",
				        key: key
		        }
			        this.rakSearch = [];
		        }
                
                if (key.length >= 2) {
                    try {
                        const response = await this.$axios.get(this.$baseurl + '/masterData/meta/list_rak_meta?idoutlet=' + this.setidoutletserak + '&key=' + key + '&limit=' + this.rakSearchPagination.limit + '&offset=' + this.rakSearchPagination.offset, this.requestHeaders);
                        if (response.status === 200) {
                            if (response.data.status === true) {
                                this.leght_data=response.data.lenght_data;
                                $('#loadingPage').hide();
                                $('#loadingPage').removeClass('overlayLoading');
                                if(this.leght_data > 0){
                                    $("#textTopRak").text("Ditemukan "+this.leght_data+" Rak dengan kata '"+key+"'");
                                }else{
                                    $("#textTopRak").text("Tidak menemukan '"+key+"'");
                                }
                                var data = response.data.data;
								this.rakSearchPagination.length += data.length
	                            for (var i = 0; i < data.length; i++) {
		                            this.rakSearch.push({
			                            nama: data[i].nama,
			                            tagrak : data[i].kategori_rak,
			                            idrak : data[i].idrak,
			                            nota_transaksi: data[i].jumlah_nota_transaksi,
			                            pack_terisi: parseInt(data[i].isi_gantung) + parseInt(data[i].isi_gulung) + parseInt(data[i].isi_lipat),
		                            })
	                            }
	                            this.rakSearchPagination.pageNumber++
	                            $('#loadingSpinnerRakSearch').hide()
                             
                            }
                        }
                    } catch (e) {
	                    $('#loadingSpinnerRakSearch').hide()
                    }
                } else {
	                $('#loadingSpinnerRakSearch').hide()
                    this.rakSearch = [];
                    $('#loadingPage').hide();
                    $('#loadingPage').removeClass('overlayLoading');
                    $("#textTopRak").text("Minimal 2 karakter")
                }
            },
            // akhir func search //
            //fungsi get//
            async getrak(reset = false){
	            if (reset) {
		            this.rakPagination.pageNumber = 0
	            }
            	
	            if (this.rakPagination.offset === 0) {
		            this.rak=[];
		            $('#loadingPage').show();
		            $('#loadingPage').addClass('overlayLoading');
	            }
                var sort_get;
                var order_get;
                try {
                    sort_get = this.rakPagination.sortBy;
                    order_get = this.rakPagination.orderBy;
                    var limit =this.rakPagination.limit;
                    var offset= this.rakPagination.offset;
                    const response = await this.$axios.get(this.$baseurl + '/masterData/meta/list_rak_meta?idoutlet=' + this.setidoutletserak +'&sort_by=' + sort_get + '&order_by='+ order_get + '&limit=' + limit + '&offset=' + offset, this.requestHeaders);
                    if (response.data.status === true) {
                        this.page_number++;
                        var data = response.data.data;
                        this.leght_data=response.data.lenght_data;
                        this.rakPagination.length += data.length
                        for (var i = 0; i < data.length; i++) {
                            this.rak.push({
                                nama: data[i].nama,
                                tagrak : data[i].kategori_rak,
                                idrak : data[i].idrak,
	                            nota_transaksi: data[i].jumlah_nota_transaksi,
	                            pack_terisi: parseInt(data[i].isi_gantung) + parseInt(data[i].isi_gulung) + parseInt(data[i].isi_lipat),
                            })
                        }
                        if(this.leght_data > 0){
                            $("#iconsearchrak").show()
                        }else{
                            $("#iconsearchrak").hide()
                        }
	
	                    this.rakPagination.pageNumber++
	                    $('#loadingSpinnerRak').hide()
                        
                        $('#loadingPage').removeClass('overlayLoading');
                        $('#loadingPage').hide();
                    }else{
	                    $('#loadingSpinnerRak').hide()
                    }

                }catch (e) {
                	this.$catch_error_response(e)
	                $('#loadingSpinnerRak').hide()
	                $('#loadingPage').hide();
	                $('#loadingPage').removeClass('overlayLoading');
                }
            },

            // sortir func //
            async selectSortingRaks(key) {
                $("#cardrak").hide();
                $("#spinnerWorkshop").prop("style", "display:inline-block");
                switch (key) {
                    case "asc":
                        $('#dropdownMenuButton2').text("Urut Dari A - Z ")
                        this.getRakSortingMaster(1)
                        break;
                    case "desc":
                        $('#dropdownMenuButton2').text("Urut Dari Z - A ")
                        this.getRakSortingMaster(2)
                        break;
                    case "terbaru":
                        $('#dropdownMenuButton2').text("Urut Dari Terbaru ")
                        this.getRakSortingMaster(3)
                        break;
                    case "terlama":
                        $('#dropdownMenuButton2').text("Urut Dari Terlama ")
                        this.getRakSortingMaster(4)
                        break;
                    default:
                        $('#dropdownMenuButton2').text("Urutkan ")
                }
            },
            async getRakSortingMaster(datasorting) {
                $('#loadingPage').show();
                $('#loadingPage').addClass('overlayLoading');
                var sort_by
                var order_by
                try {
                    if (datasorting === 1) {
                        sort_by = "nama";
                        order_by = "ASC";
                    } else if (datasorting === 2) {
                        sort_by = "nama";
                        order_by = "DESC";
                    } else if (datasorting === 3) {
                        sort_by = "idrak";
                        order_by = "DESC";
                    } else if (datasorting === 4) {
                        sort_by = "idrak";
                        order_by = "ASC";
                    } else {
                        return
                    }


                    //var key = jika ada search nanti dipake
                    // var idowner = localStorage.getItem('idowner');
                    const res = await this.$axios.get(this.$baseurl + '/masterData/meta/list_rak_meta?idoutlet=' + this.setidoutletserak + '&order_by=' + order_by + '&sort_by=' + sort_by, this.requestHeaders)
                    if (res.status === 200) {
                        if (res.data.status === true) {
                            $('#loadingPage').hide();
                            $('#loadingPage').removeClass('overlayLoading');
                            this.rak=[];
                            var data = res.data.data;
                            for (var i = 0; i < data.length; i++) {
                                this.rak.push({
                                    nama: data[i].nama,
                                    tagrak : data[i].kategori_rak,
                                    idrak : data[i].idrak,
	                                nota_transaksi: data[i].jumlah_nota_transaksi,
	                                pack_terisi: parseInt(data[i].isi_gantung) + parseInt(data[i].isi_gulung) + parseInt(data[i].isi_lipat),
                                })
                            }
                            $("#spinnerWorkshop").prop("style", "display:none");
                            $("#cardrak").show();
                        }
                    }
                } catch (e) {
                	this.$catch_error_response(e)
	                this.isClicked = false
                }
            },
            //akhir func sortir//
	        filter(payload) {
		        this.rakPagination = payload.data;
		        this.getrak()
		        $("#dropdownMenuButton-" + payload.type).html(payload.textSorting)
	        },
        },
        watch: {
            searchKey() {
              this.searchRak()
            },
            listRakCalled() {
                if (!this.listRakCalled) {
                    this.listRakCalled = true
                    this.scroll()
                }
            }
        }
    }
</script>

<style scoped>
    .image {
        margin-top: 185px;
        color: #333333;;
    }

    .imageSearch {
        float: right;
        margin-right: 0px;
        height: 24px;
        width: 24px;
        margin-top: 0px;
    }

    .inputSearch {
        padding-left: 10px;
        padding-right: 10px;
        width: 100%;
        border: none;
    }

    .inputSearch:focus {
        outline: none;
    }

    #loading-bar-spinner.spinner {
        left: 50%;
        margin-left: -20px;
        top: 50%;
        margin-top: -20px;
        position: absolute;
        z-index: 19 !important;
        animation: loading-bar-spinner 400ms linear infinite;
    }

    #loading-bar-spinner.spinner .spinner-icon {
        width: 40px;
        height: 40px;
        border: solid 4px transparent;
        border-top-color: #a6a9a9 !important;
        border-left-color: #a6a9a9 !important;
        border-radius: 50%;
    }

    @keyframes loading-bar-spinner {
        0% {
            transform: rotate(0deg);
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
            transform: rotate(360deg);
        }
    }

    .card-2{
        margin-top: 68px;
        margin-bottom: 100px;
    }

    .test{
        display: none;
        box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);
        border-radius: 3px;
        position: absolute;
        right: 0;
        top: 0;
        background: white;
    }
    .pointer {
        right: 35%;
    }
    @media screen and (max-width: 992px) {
        .pointer {
            right: 25%;

        }
    }
    @media screen and (max-width: 720px) {
        .pointer {
            right: 20%;

        }
    }
    @media screen and (max-width: 600px) {
        .pointer {
            right: 10%;

        }
    }
</style>